@if (hasAccess) {
    <a
        (click)="onClick()"
        [routerLink]="url"
    >
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </a>
}
@if (!hasAccess) {
    <span>
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </span>
}
<ng-template #contentTpl><ng-content></ng-content></ng-template>
